/* eslint @typescript-eslint/naming-convention: 0 */

import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export interface DrawerTabViewParams {
  experience_id: string;
  tab_key: string;
}

/**
 * 発火タイミング: 施設情報ドロワーでタブが表示された時。開いた直後の初期表示タブも含む。
 *
 * どの切り口が読まれるかを見て推奨タブ雛形の見直しに使う（HY-002）。同じタブを押し直した時は送らない。
 */
export const sendGAWabunkaDrawerTabViewEvent = (params: { experienceId: string; tabKey: string }) => {
  sendWabunkaGAEvent('drawer_tab_view', {
    experience_id: params.experienceId,
    tab_key: params.tabKey,
  });
};
